import * as PIXI from 'pixi.js'
import gsap from 'gsap'
import MyApplication from '../../../pixi/MyApplication'
import AssetsManager from '../../../pixi/AssetsManager'
import MathUtil from '../../../util/MathUtil'

/**
 * HeartViewクラス
 */
class HeartView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //速度
  private _speedX: number = 0
  private _speedY: number = 0

  //スケール
  private _s: number = 3

  //アップデートメソッド
  private _update: () => void

  // ---------------------------------------------------------------------------------------------------------
  // --	HeartView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //ハート配置
    const heart: PIXI.Sprite = AssetsManager.instance.createSpriteByName('heart.png')
    heart.anchor.set(0.5)
    // heart.scale.set(1)
    this.addChild(heart)

    //角度をランダムに
    const radian: number = MathUtil.degreeToRadian(Math.random() * 360)
    const speed: number = 3 + Math.random() * 2
    this._speedX = Math.cos(radian) * speed
    this._speedY = Math.sin(radian) * speed

    //アップデート
    this._update = this.update.bind(this)
    MyApplication.app.ticker.add(this._update)
  }

  /**
   * アップデート
   */
  private update() {
    //移動
    this.x += this._speedX
    this.y += this._speedY
    this.rotation += MathUtil.degreeToRadian(this._speedX / 3)

    //拡大
    if (this._s < 12) {
      this._s += 0.1
      this.scale.set(this._s)
    }
    //フェードアウト
    else {
      this.alpha -= 0.01
      if (this.alpha <= 0.0) {
        MyApplication.app.ticker.remove(this._update)
        this.destroy()
      }
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default HeartView
